/** @format */

import { NAME_PORTAL_CODE } from '@/utils/gatsby/constants';
import { useState } from 'react';
import { useQueryParam, StringParam } from 'use-query-params';

export const usePortalCode = () => {
  const [portalCodeParam = NAME_PORTAL_CODE] = useQueryParam('portalCode', StringParam);
  const [utmSource] = useQueryParam('utm_source', StringParam);

  const portalCode = utmSource ? getPortalCodeFromUtmSource(utmSource) : portalCodeParam;
  const [isExternalPortalCode, setIsExternalPortalCode] = useState(portalCode !== NAME_PORTAL_CODE);
  const isUtmSource = !!utmSource;
  return { portalCode, isExternalPortalCode, setIsExternalPortalCode, isUtmSource };
};

const getPortalCodeFromUtmSource = (utmSource: string): string => {
  switch (utmSource) {
    case 'ErasmusPlay':
      return 'ERPL';
    default:
      return utmSource;
  }
};
